
export default abstract class BaseFilter {
	public abstract getAllParams(): {};
}